export const RESOURCE = 'adminpayment';
export const ACTIONS = {
    GetByReferenceId: '/referenceId',
    GetByMembershipNumber: '/membershipnumber',
    Create: '',
    Update: '',
    CancelByReferenceId: '/cancel',
    RefundByReferenceId: '/refund',
    SettleByReferenceId: '/settle'
}